import { Component, OnInit } from '@angular/core';

import * as _ from 'lodash-es';

import { StateService } from '@uirouter/angular';
import { AdminService } from '../../../services/core.admin.service';
import { FilterService } from '../../../services/core.filter.service';
import { UiService } from '../../../services/core.ui.service';
import { UserRest } from '../../../services/core.user.rest.service';
import { SettingService } from '../../../services/core.setting.service';
import { GfTitleService } from '../../../services/core.title.service';
import { doPromiseAll } from '../../../config/core.promise-utils';
import { getParamsFromAllowedKeys } from '../../../config/core.httpclient-utils';

@Component({
    selector: 'admin-users-view',
    template: require('./admin.users.component.html')
})
export class AdminUsersViewComponent implements OnInit {
    protected showSessionsUser: any;
    protected loading = false;

    protected filters: any = { main_fields: [] };
    protected sortFields: any = { id: 'Join Date', unixName: 'Unix Name' };
    private sort: any = {}; // this.filterService.getSortValues();
    private paging: any = {}; // this.filterService.getPagingValues();

    protected adminOpen = false;
    protected users: any = false;
    private onOff = { 'Auto approve': 0, 'Admin approval required': 1 };

    protected statuses = {
        '-1': 'Pending approval',
        '0': 'Pending',
        '1': 'Active',
        '2': 'Deleted',
        '3': 'Suspended'
    };

    protected authenticationModeChoices = {
        'DB': 'db',
        'LDAP': 'ldap',
        'Mixed': 'mixed'
    };
    protected registrationModeChoices = {
        'Open': 0,
        'Hidden': 1,
        'Off': 2
    };
    protected yesNo = {
        'Yes': 1,
        'No': 0
    };
    protected approveYesNo = {
        'Yes': 0,
        'No': 1
    };

    private stateParams: any = {};

    // Default values
    protected authenticationMode = 'db';
    protected registrationMode = 0;
    protected approveUsers = 1;
    protected requireUserCaptcha = 0;
    protected validateEmailDomains = '';

    protected settingsLoaded = false;

    constructor(
        public stateService: StateService,
        
        private adminService: AdminService,
        private filterService: FilterService,
        private $window: Window,
        private uiService: UiService,
        private userRest: UserRest,
        private settingService: SettingService,
        private titleService: GfTitleService,
    ) { }

    ngOnInit() {
        this.titleService.setTitle('Site Admin', 'Users');

        var promises = {
            authenticationMode: this.getSettingPromise('system.accountCreationAuthenticationMode', this.authenticationMode),
            registrationMode: this.getSettingPromise('system.accountRegistrationMode', this.registrationMode),
            approveUsers: this.getSettingPromise('system.approveUsers', this.approveUsers),
            requireUserCaptcha: this.getSettingPromise('system.requireUserCaptcha', this.requireUserCaptcha),
            validateEmailDomains: this.getSettingPromise('system.validateEmailDomains', this.validateEmailDomains)

        };

        doPromiseAll(promises)
        .then(
            (results) => {
                this.authenticationMode = this.getSettingValue(results, 'authenticationMode.settingValue', this.authenticationMode);
                this.registrationMode = this.getSettingValue(results, 'registrationMode.settingValue', this.registrationMode);
                this.approveUsers = this.getSettingValue(results, 'approveUsers.settingValue', this.approveUsers);
                this.requireUserCaptcha = this.getSettingValue(results, 'requireUserCaptcha.settingValue', this.requireUserCaptcha);
                this.validateEmailDomains = this.getSettingValue(results, 'validateEmailDomains.settingValue', this.validateEmailDomains);
            }, (result) => {
                console.log(result);
            }
        ).finally(() => {
            this.settingsLoaded = true;
        });

        this.setFilterValues();
        this.getUsers();
    };

    onApplyFilters () {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters () {
        this.paging.page_num = 1;
        this.filters = {
            main_fields: this.getBaseFilters()
        };
        this.applyFilters();
    };

    onSort (params) {
        this.sort = {
            sort_field: _.get(params, 'key', 'id'),
            sort_dir: _.get(params, 'sortDir', 'desc')
        };
        this.applyFilters();
    };

    onPaging (params) {
        _.assignIn(this.paging, params);
        this.applyFilters();
    };

    exportQuery(format: string) {
        //ToDo: change this to use angular's route object when
        //the router is migrated to angular from angularjs
        // Build the params the same way getUsers() does (via getFetchArgs),
        // NOT from raw stateService.params: getFetchArgs() strips
        // undefined/null/'' so "Any"/unset filters never serialize as
        // status=undefined/status=any/since=undefined, which the backend would
        // treat as real filters and return an empty file.
        const params: any = this.filterService.getFetchArgs({ group: 'false' }, this.stateParams);

        params['page_size'] = 0;
        params['format'] = format;
        params['download'] = true;

        // Only include API-relevant params using whitelist
        const allowedKeys = ['group', 'text', 'ip', 'status', 'member', 'admin', 'since', 'page_num', 'page_size', 'sort_field', 'sort_dir', 'format', 'download'];
        const queryString = getParamsFromAllowedKeys(params, allowedKeys).toString();

        window.open('/api/user?' + queryString, '_blank'); // Open in a new tab
    };

    authModeText (authMode) {
        if (authMode) {
            return authMode.toUpperCase();
        }
        return '';
    };

    setStatus (value, user) {
        //Notice: the name is misleading, but "register" is a call to POST /api/user
        //It's an endpoint that can be used to create/update a user
        this.userRest.register({ id: user.id, unixName: user.unixName, status: value })
            .then((r) => {
                user.status = value;
                this.uiService.message.showSuccess(user.unixName + ' is now ' + this.statuses[value], 'Success');
            })
            .catch((r) => {
                var msg = 'Could not set status "' + this.statuses[value] + '" to user ' + user.unixName;
                if (!_.isEmpty(r.data)) {
                    msg += '\nThis user has some invalid profile data, please edit the user profile first';
                }
                this.uiService.message.showError(msg, 'Failure');
            });
    };

    deleteUser (user) {
        this.userRest.delete(user.unixName)
            .then((r) => {
                user.status = 2;
                var msg = user.unixName + " is now in Deleted status.  All Group and Project memberships have been removed.";
                this.uiService.message.showSuccess(msg, 'Delete User');
            })
            .catch((r) => {
                console.log(r);
                var msg = 'Could not delete ' + user.unixName;
                this.uiService.message.showError(msg, 'Delete User');
            });
    };

    setAuthenticationMode (value) {
        if (value == undefined || this.authenticationMode == value) return false;
        this.adminService.postConfig({ section: 'config', refId: 0, settingName: 'system.accountCreationAuthenticationMode', settingValue: value })
            .then(() => {
                this.authenticationMode = value;
            }, () => {});
    };

    setRegistrationMode (value) {
        if (value == undefined || this.registrationMode == value) return false;
        this.adminService.postConfig({ section: 'config', refId: 0, settingName: 'system.accountRegistrationMode', settingValue: value })
            .then(() => {
                this.registrationMode = value;
            }, () => {});
    };

    setApproveUsers (value) {
        if (value == undefined || this.approveUsers == value) return false;
        this.adminService.postConfig({ section: 'config', refId: 0, settingName: 'system.approveUsers', settingValue: value })
            .then(() => {
                this.approveUsers = value;
            }, () => {});
    };

    setRequireUserCaptcha (value) {
        if (value == undefined || this.requireUserCaptcha == value) return false;

        this.adminService.postConfig({ section: 'config', refId: 0, settingName: 'system.requireUserCaptcha', settingValue: value })
            .then(() => {
                this.requireUserCaptcha = value;
            }, () => {});
    };

    getUserEditTitle (user) {
        if (_.get(user, 'rel.lock', false)) {
            return 'This user is locked for failed passwords.  Click to view user details, and reset the failure count there.';
        } else {
            return 'Edit user profile';
        }
    };

    setValidateEmailDomains() {
        var value = this.validateEmailDomains;
        this.adminService.postConfig({ section: 'config', refId: 0, settingName: 'system.validateEmailDomains', settingValue: value })
            .then(() => {
                if (!value?.length) {
                    this.uiService.message.showSuccess(`Removed the email validation URL`, "Site Admin - User Email Validation");
                } else {
                    this.uiService.message.showSuccess(`Updated email validation URL to ${value}`, "Site Admin - User Email Validation");
                }
            }, () => {}
        );
    }

    getSettingPromise(settingName, defaultValue) {
        return this.settingService.config(settingName, defaultValue);
    }

    getSettingValue(results, settingName, defaultValue) {
        var ret = _.get(results, settingName, defaultValue);
        if (ret === '') return defaultValue;
        return ret;
    }

    setFilterValues() {
        this.setStateParams();
        this.filters = {
            main_fields: this.filterService.setFilterValues(this.getBaseFilters(), this.stateParams)
        };
    }

    getUsers() {
        this.users = false;

        var fetchArgs = this.filterService.getFetchArgs(
            { group: 'false', rel: 'lock,sessions' },
            this.stateParams
        );

        this.adminService.users(fetchArgs)
            .then((response) => {
                this.users = _.get(response, 'items', []);
            }, (response) => {
                console.log(response);
                this.users = [];
            });
    }

    applyFilters(overrides = {}) {
        var newParams = _.pickBy(_.extend(
            this.filterService.getFilterValues(
                _.get(this.filters, 'main_fields', [])
            ),
            this.sort,
            this.paging,
            overrides
        ), (value) => {
            return (undefined != value && null != value && value != '');
        });

        this.stateService.go('.', newParams, { inherit: false, notify: true }).then(
            () => {
                this.setFilterValues();
                this.getUsers();
            }
        );
    }

    setStateParams() {
        this.stateParams = _.pickBy(
            this.stateService.params, 
            (v) => { return (! _.isObject(v) && (typeof v !== 'function')); }
        );
        this.sort = this.filterService.getSortValues();
        this.paging = this.filterService.getPagingValues();
    }

    getBaseFilters() {
        var anyOption = this.filterService.getAnyFilterObj();
        return [
            { alias: "text", fieldName: "Text Search", value: "", fieldType: 4, isExtraField: false },
            { alias: "ip", fieldName: "IP Address", value: "", fieldType: 4, isExtraField: false },
            {
                alias: "status",
                fieldName: "Status",
                value: anyOption,
                fieldType: 1,
                isExtraField: false,
                fieldElements: [
                    anyOption,
                    { id: '-1', label: "Pending Approval" },
                    { id: '0', label: "Pending" },
                    { id: '1', label: "Active" },
                    { id: '2', label: "Deleted" },
                    { id: '3', label: "Suspended" }
                ]
            },
            { alias: "member", fieldName: "Member Of (Group)", value: "", fieldType: 4, isExtraField: false },
            {
                alias: "admin",
                fieldName: "Site Admin",
                value: anyOption,
                fieldType: 1,
                isExtraField: false,
                fieldElements: [
                    anyOption,
                    { id: '1', label: "Yes" },
                    { id: '0', label: "No" }
                ]
            },
            {
                alias: "since",
                fieldName: "Active Since",
                value: anyOption,
                fieldType: 1,
                isExtraField: false,
                fieldElements: [
                    anyOption,
                    { id: '-15 minutes', label: "15 Minutes" },
                    { id: '-1 hour', label: "1 Hour" },
                    { id: 'midnight yesterday', label: "Today" },
                    { id: 'midnight last monday', label: "This Week" },
                ]
            }
        ];
    }
}